import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { observable, autorun, action, toJS } from 'mobx';
import { observer, map } from 'mobx-react'

import {DictionaryTrans,autobind} from './DictionaryTrans';
import reactMixin  from 'react-mixin';
import Settings from './Settings';
import ls from 'local-storage';
import {IconClose} from './Icons';

@observer
@reactMixin.decorate(DictionaryTrans)
@reactMixin.decorate(autobind(Object.keys(DictionaryTrans)))
export default class SocialGraphic extends Component {


   photoStatus = observable.map();

  constructor(props) {

    super(props);
    this.trans = this.props.dictionaryStorage.getCurrentLangDict;

    $(window).on('PictureBody-addSocialImage',(e,key)=>{
      this.photoStatus.set(key,'ready');
    })

  }


  async uploadPhotos(val,key){

   // if ( this.photoStatus.get(key) == 'loading' || this.photoStatus.get(key) == 'ready' ) return;
    if ( this.photoStatus.get(key) == 'loading' ) return;
    if ( Settings.getSettingsMediaListCount < 1 )
    //if( ($('#bf-media-gallery.js-bf-media:first li').length < 1 ) )
    {
      Settings.setFirstUpload(true,false);

    }
    else
    {
      Settings.setFirstUpload(false);
    }

    if ( Settings.getSettingsFirstUploadAccepted || !Settings.getSettingsFirstUpload ) {

      this.photoStatus.set(key, 'loading');

      let obj = val;
      obj._key = key;
      //obj.source = obj.images[0].source;

      $(window).trigger('SocialGraphic-upload', obj);
    }
  }

  close(){
    Settings.setSettingsSocialGraphicOpen(false);
  }


  render() {

    const trans = this.trans;
    const t = this.t;
    const langCode = this.props.dictionaryStorage.currentLang;

    return (
      <div className={"SocialGraphic " + (this.props.mobiVersion ? 'SocialGraphicMobi' : '') }>
        {
          Settings.socialGraphicOpen
          &&
          <div className="SocialGraphic-container">
            <div>
              <span className="SocialGraphic-title">{t('Click for upload photo')}</span>
              <span onClick={ ()=> { this.close() } } className="SocialGraphic-close"><IconClose/></span>
              <ul className="SocialGraphic-gallery">
              {
                _.map(Settings.getSettingsSocialPhotos.facebook,(val,key)=>{
                  return(
                    <li key={key} onClick={()=>{ this.uploadPhotos(val,key) }} className={ "SocialGraphic-image-"+this.photoStatus.get(key)} style={{'backgroundImage':'url('+val.picture+')'}}>
                      <span>
                         <div className="image-progress image-progress-small">
                           <div className="cssload-container">
                             <div className="cssload-speeding-wheel"></div>
                           </div>
                         </div>
                      </span>
                    </li>
                  )
                })
              }
              </ul>
            </div>
          </div>
        }
      </div>
    );


  }
}






